import { useDispatch, useSelector } from "react-redux";
import { Button, Loader, Modal } from "@scuf/common";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./css/dashboard.scss";
import { AppState } from "../../../../common/store/combinedReducer";
import {
  getAssignedRoles,
  getDetails,
  getPermissions,
  setCSRFToken,
  setLoading,
  setLoggedIn,
  setSelectedView,
  setVmIdNotification,
  setDownloadData,
  setSelectedPlant,
  setSelectedTenant,
} from "../../../store/action";
import AuthProvider from "../../../../common/authentication/authService";
import {
  handleRefresh,
  removeItemMetaData,
  setParams,
} from "../../../../common/utility/Dashboard/utility";
import config from "../../../../common/authentication/config";
import HeaderLanding from "../header/headerLanding";
import Sidebar from "../sidebar/sidebar";
import OrganizationPanel from "./organizationPanel";
import { handleDownload } from "../../../../common/utility/dataManagementUtils";
import { customToast } from "../../../../App";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedView = useSelector((state: AppState) => {
    return state.reducer.selectedView;
  });
  const plantName = useSelector((state: AppState) => {
    return state.reducer.plantName;
  });
  const loading = useSelector((state: AppState) => {
    return state.reducer.loading;
  });
  const activePage = useSelector((state: AppState) => {
    return state.reducer.activePage;
  });
  const permissions = useSelector((state: AppState) => {
    return state.reducer.permissions;
  });
  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });
  const permissionStatus = useSelector((state: AppState) => {
    return state.reducer.permissionStatus;
  });
  const selectedPlant = useSelector((state: AppState) => {
    return state.reducer.selectedPlant;
  });
  const csrf = useSelector((state: AppState) => {
    return state.reducer.csrf;
  });
  const csrfStatus = useSelector((state: AppState) => {
    return state.reducer.csrfStatus;
  });
  const vmIdNotification = useSelector((state: AppState) => {
    return state.reducer.vmIdNotification;
  });
  const orgsDropDownData = useSelector((state: AppState) => {
    return state.reducer.orgsDropDownData;
  });
  const assignedRoles = useSelector((state: AppState) => {
    return state.reducer.assignedRoles;
  });
  const assignedRolesStatus: any = useSelector((state: AppState) => {
    return state.reducer.assignedRolesStatus;
  });
  const selectedTenant: any = useSelector((state: AppState) => {
    return state.reducer.selectedTenant;
  });
  const tenantDropDownData = useSelector((state: AppState) => {
    return state.reducer.tenantDropDownData;
  });
  const downloadResponse = useSelector((state: AppState) => {
    return state.reducer.downloadResponse;
  });
  const downloadStatus = useSelector((state: AppState) => {
    return state.reducer.downloadStatus;
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [getRefreshToken, setRefreshtoken] = useState(false);
  const [token, setToken] = useState("");
  const [isTabActive, setTabActive] = useState(true);
  const [intervalID, setIntervalID] = useState(0);

  let sessionTimer: any;
  let timer: any = 0;
  let popupTimer: any = 0;

  const refreshToken = () => {
    clearTimeout(intervalID);
    popupTimer = 0;
    setRefreshtoken(false);
  };
  useEffect(() => {
    if (
      permissions?.length > 0 &&
      localStorage.getItem("access_token") !== undefined &&
      permissionStatus !== 500
    ) {
      const selectedIndex = activePage;
      if (
        orgDataStatus === 0 &&
        orgsDropDownData.length > 0 &&
        orgDataStatus !== undefined
      ) {
        const selectedPlantToFetch = orgsDropDownData[selectedIndex]?.value;
        if (
          vmIdNotification !== null &&
          selectedPlant === selectedPlantToFetch
        ) {
          fetchDetails(selectedPlant, vmIdNotification);
        } else if (
          vmIdNotification === null &&
          selectedPlant === selectedPlantToFetch
        ) {
          fetchDetails(selectedPlant);
          checkUserRole(selectedPlant);
        } else {
          dispatch(setLoggedIn(false));
        }
      } else if (orgDataStatus === 0) {
        fetchDetails(selectedPlant);
      } else if (orgDataStatus !== 0) {
        dispatch(setLoggedIn(false));
      }
    } else if (
      permissionStatus !== 0 &&
      (permissions === null ||
        (permissions?.length <= 0 &&
          localStorage.getItem("access_token") !== undefined) ||
        permissionStatus === 500)
    ) {
      dispatch(setLoggedIn(false));
      dispatch(setVmIdNotification(null));
      navigate("/loginFailed");
    }
  }, [permissions, orgDataStatus, vmIdNotification, selectedPlant, activePage]);

  const checkUserRole = (selectedPlant: any) => {
    if (assignedRolesStatus === 0 && assignedRoles?.length === 0) {
      dispatch(
        getAssignedRoles({
          authorization: localStorage.getItem("access_token"),
          siteId: selectedPlant,
          tenantId: selectedTenant,
        }),
      );
    }
  };

  const fetchDetails = (orgs: string, vmId?: string) => {
    if (vmId) {
      dispatch(
        getDetails({
          authorization: localStorage.getItem("access_token"),
          orgs,
          vmId,
        }),
      );
    } else {
      dispatch(
        getDetails({
          authorization: localStorage.getItem("access_token"),
          orgs,
        }),
      );
    }
    dispatch(setLoggedIn(true));
  };

  useEffect(() => {
    if (csrfStatus === 200 || csrfStatus !== 0) {
      const sub: any = AuthProvider().getUserId();
      dispatch(setCSRFToken({ status: 0, data: false }));
      if (sub && csrf === true && permissions?.length === 0) {
        dispatch(
          getPermissions({
            userSub: sub,
            authorization: localStorage.getItem("access_token"),
          }),
        );
      } else if (csrf === false) {
        setTimeout(() => {
          navigate("/loginFailed");
        }, 500);
      } else {
        dispatch(setLoading(false));
      }
    } else if (csrfStatus !== 200 && csrfStatus !== 0) {
      setTimeout(() => {
        navigate("/loginFailed");
      }, 500);
    }
  }, [csrfStatus, csrf]);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refer =
      searchParams.get("refer") ||
      searchParams.get("referrer") ||
      searchParams.get("referer") ||
      searchParams.get("source") ||
      null; // preferred for refer (support multiple param names)
    const rawSiteId = searchParams.get("siteId");
    const parsedTenantFromSiteId =
      rawSiteId && rawSiteId.includes("/tenantId=")
        ? rawSiteId.split("/tenantId=")[1]
        : null;
    const siteId =
      rawSiteId && rawSiteId.includes("/tenantId=")
        ? rawSiteId.split("/tenantId=")[0]
        : rawSiteId;
    const tenantId = searchParams.get("tenantId") || parsedTenantFromSiteId;
    const urlDashboard = window.location.pathname?.split("/")[1];
    //console.log("dashboard navigated", refer, siteId, tenantId, urlDashboard);
    // if (refer && siteId && tenantId) {
    //   setParams(siteId, tenantId, urlDashboard);
    //   AuthProvider().requestAuthCode();
    // } else
    if (siteId && tenantId) {
      setParams(siteId, tenantId, urlDashboard, refer);
      dispatch(setSelectedPlant(siteId));
      const tenantIndex =
        tenantDropDownData?.findIndex(
          (data: any) => data?.value === tenantId,
        ) ?? 0;
      // Only trigger the auth redirect when navigation included a refer (external redirect)
      if (refer || permissions.length === 0) {
        dispatch(setLoading(true));
        AuthProvider().requestAuthCode();
      }
      dispatch(
        setSelectedTenant({
          selectedTenantIndex: tenantIndex,
          selectedTenant: tenantId,
        }),
      );
    } else if (
      localStorage.getItem("logged_user") === null ||
      localStorage.getItem("logged_user") === JSON.stringify(false)
    ) {
      localStorage.setItem("logged_out_from", "dashboard /");
      navigate("/");
    } else {
      localStorage.setItem("logged_user", JSON.stringify(true));
      const selectedViewVal = {
        selectedView: selectedView || "Dashboard",
        plantName,
        activePage,
      };
      dispatch(setSelectedView(selectedViewVal));
      if (permissions?.length === 0) {
        dispatch(setLoading(true));
        handleRefresh(true, dispatch, setToken, "Dashboard");
      } else {
        dispatch(setLoading(false));
      }
    }
    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);
    dispatch(setVmIdNotification(null));
    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
      removeItemMetaData();
    };
  }, []);

  const handleFocus = () => {
    localStorage.setItem("activeTab", selectedView);
    setTabActive(true);
    clearTimeout(timer);
  };

  const handleBlur = () => {
    setTabActive(false);
    timer = setTimeout(() => {
      if (localStorage.getItem("activeTab") == selectedView) {
        setRefreshtoken(true);
      }
    }, config.INTERVAL); // 2hours
  };

  useEffect(() => {
    if (isTabActive === false) {
      if (getRefreshToken === true) {
        popupTimer = setTimeout(() => {
          // if (clicked === false)
          setRefreshtoken(false);
          localStorage.setItem("logged_out_from", "Dashboard");
          navigate("/logout");
        }, 60 * 1000);
        setIntervalID(popupTimer);
      }
    }
  }, [getRefreshToken, isTabActive]);

  const sessionExtendPopup = () => {
    return (
      <Modal
        className="userDeleteModal"
        closeIcon={false}
        open={getRefreshToken}
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
        data-testid="user-delete-modal"
      >
        <Modal.Header className="">You have been idle!</Modal.Header>
        <Modal.Content className="confirmModal">
          <span className="modal-text-vm">You will logged out in 1 minute</span>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="primary"
            size="small"
            content="Stay"
            className="save-secondary"
            onClick={refreshToken}
          />
        </Modal.Footer>
      </Modal>
    );
  };

  const renderViewSelected = () => {
    localStorage.setItem("activeTab", selectedView);

    return (
      <div className="dashboard-main" data-testid="dashboard-container">
        <HeaderLanding
          onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
          sidebarOpen={sidebarOpen}
        />
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        {loading ? (
          <Loader
            id="mock-loader"
            overlayColor="rgba(0,0,0,0.2)"
            className={`loader-overlay ${sidebarOpen ? "sidebar-open" : ""}`}
          >
            <div className="placeholder" />
          </Loader>
        ) : null}
        <div
          className={`dashboard-content ${sidebarOpen ? "sidebar-open" : ""}`}
        >
          <div className="dashboard-container">
            <div className="left-container" data-testid="left-container">
              <OrganizationPanel token={token} setToken={setToken} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {sessionExtendPopup()}
      {renderViewSelected()}
    </div>
  );
};

export default Dashboard;
